export const giveCompensatedLeaveConfig = {
  userId: '',
  description: '',
  durationInSeconds: 0,
};